import React from "react";
import { useNavigate } from "react-router-dom";
import "./LandingPage.css";

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="landing-page">
      {/* Skip links for accessibility */}
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <a href="#navigation" className="skip-link">
        Skip to navigation
      </a>

      <header className="landing-header">
        <h1 className="landing-title">Lucky Dog Tavern</h1>
        <p className="landing-subtitle">A Local Favorite Since 2019</p>

        <nav
          id="navigation"
          className="menu-navigation"
          role="navigation"
          aria-label="Main menu navigation"
        >
          <button
            className="menu-nav-button wine-button"
            onClick={() =>
              navigate(
                window.location.pathname.includes("/restaurant/")
                  ? `/restaurant/${
                      window.location.pathname.split("/")[2]
                    }/drinks?menuType=wine`
                  : "/drinks?menuType=wine"
              )
            }
            aria-label="View our wine menu"
          >
            Wine Menu
          </button>
          <button
            className="menu-nav-button beer-button"
            onClick={() =>
              navigate(
                window.location.pathname.includes("/restaurant/")
                  ? `/restaurant/${
                      window.location.pathname.split("/")[2]
                    }/drinks?menuType=beer`
                  : "/drinks?menuType=beer"
              )
            }
            aria-label="View our beer menu"
          >
            Beer Menu
          </button>
          <button
            className="menu-nav-button drinks-button"
            onClick={() =>
              navigate(
                window.location.pathname.includes("/restaurant/")
                  ? `/restaurant/${
                      window.location.pathname.split("/")[2]
                    }/drinks?menuType=cocktails`
                  : "/drinks?menuType=cocktails"
              )
            }
            aria-label="View our cocktails menu"
          >
            Drink Menu
          </button>
          <button
            className="menu-nav-button spirits-button"
            onClick={() =>
              navigate(
                window.location.pathname.includes("/restaurant/")
                  ? `/restaurant/${
                      window.location.pathname.split("/")[2]
                    }/spirits`
                  : "/spirits"
              )
            }
            aria-label="View our spirits menu"
          >
            Spirits Menu
          </button>
        </nav>
      </header>

      <main id="main-content" className="landing-main">
        <section className="about-section" aria-label="About Lucky Dog Tavern">
          <div className="about-content">
            {/* Paw print icon */}
            <div
              className="about-icon"
              style={{ textAlign: "center", marginBottom: "2rem" }}
            >
              <span
                style={{ fontSize: "6rem", color: "var(--wine-red, #722f37)" }}
              >
                🐾
              </span>
            </div>

            <h2
              className="about-title"
              style={{
                textAlign: "center",
                color: "var(--wine-red, #722f37)",
                marginBottom: "2rem",
              }}
            >
              Welcome to Lucky Dog Tavern!
            </h2>

            <div className="about-text">
              <p>
                Located in northern Rhode Island, Lucky Dog Tavern offers a
                unique dining experience combining rustic charm with a modern
                culinary twist. Our passion for exquisite food is matched only
                by our dedication to curating a diverse and exceptional wine and
                spirit list.
              </p>

              <h3
                style={{
                  color: "var(--wine-red, #722f37)",
                  marginTop: "2rem",
                  marginBottom: "1rem",
                }}
              >
                Our Philosophy
              </h3>
              <p>
                We believe that a great meal deserves a great companion. We have
                curated this wine list to be a collection of great wines known
                around the world as well as local favorites and some lesser
                known producers/varietals that, well, simply taste amazing.
              </p>
              <p>
                Behind our bar, we honor the classics—every Manhattan, Old
                Fashioned, and Martini is crafted with traditional techniques
                and premium ingredients. But we also love to push boundaries
                with our specialty cocktails, putting creative spins on beloved
                favorites. Our bartenders take genuine pride in balancing each
                drink, ensuring every sip is smooth, refined, and perfectly
                harmonized. Whether you're ordering a time-tested classic or one
                of our inventive creations, you can expect the same attention to
                detail and passion for the craft.
              </p>
              <p>
                Our team is committed to providing impeccable service and a
                warm, inviting atmosphere for all our guests. That's why we take
                pride in ensuring every dish and every glass tells a story.
              </p>
            </div>

            <div className="restaurant-info">
              <h3 style={{ color: "var(--wine-red, #722f37)" }}>Visit Us</h3>
              <div className="info-grid">
                <div className="info-item">
                  <h4>Hours</h4>
                  <p>Closed Monday & Tuesday</p>
                  <p>Wed - Sun: 12:00 PM - Chef's Discretion</p>
                </div>

                <div className="info-item">
                  <h4>Location</h4>
                  <p>82 School Street</p>
                  <p>Forestdale, RI 02824</p>
                </div>

                <div className="info-item">
                  <h4>Contact Us</h4>
                  <p>Phone: (401) 488-4777</p>
                  <p>Email: luckydogtavern@gmail.com</p>
                </div>
              </div>
            </div>

            <div className="call-to-action">
              <h3>Explore Our Menus</h3>
              <p>Discover our extensive drink and spirits selection</p>
              <div className="cta-buttons">
                <button
                  className="cta-button wine-cta"
                  onClick={() =>
                    navigate(
                      window.location.pathname.includes("/restaurant/")
                        ? `/restaurant/${
                            window.location.pathname.split("/")[2]
                          }/drinks?menuType=wine`
                        : "/drinks?menuType=wine"
                    )
                  }
                  aria-label="Browse our wine menu"
                >
                  Browse Wine Menu
                </button>
                <button
                  className="cta-button beer-cta"
                  onClick={() =>
                    navigate(
                      window.location.pathname.includes("/restaurant/")
                        ? `/restaurant/${
                            window.location.pathname.split("/")[2]
                          }/drinks?menuType=beer`
                        : "/drinks?menuType=beer"
                    )
                  }
                  aria-label="Browse our beer menu"
                >
                  Browse Beer Menu
                </button>
                <button
                  className="cta-button drinks-cta"
                  onClick={() =>
                    navigate(
                      window.location.pathname.includes("/restaurant/")
                        ? `/restaurant/${
                            window.location.pathname.split("/")[2]
                          }/drinks?menuType=cocktails`
                        : "/drinks?menuType=cocktails"
                    )
                  }
                  aria-label="Browse our cocktails menu"
                >
                  Browse Cocktail Menu
                </button>
                <button
                  className="cta-button spirits-cta"
                  onClick={() =>
                    navigate(
                      window.location.pathname.includes("/restaurant/")
                        ? `/restaurant/${
                            window.location.pathname.split("/")[2]
                          }/spirits`
                        : "/spirits"
                    )
                  }
                  aria-label="Browse our spirits menu"
                >
                  Browse Spirits Menu
                </button>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="landing-footer">
        <p>&copy; 2025 Lucky Dog Tavern. All rights reserved.</p>
        <p>Please drink responsibly. Must be 21+ to consume alcohol.</p>
      </footer>
    </div>
  );
};

export default LandingPage;
